





































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import User, { getAdminFlag, getLatestLicences } from "@/data/models/User";
import { localiceLicence } from "@/data/models/Licence";
import UserFormComponent from "@/components/users/UserFormDialog.vue";
import { formatUserValidationLevel } from "@/utils/LocalisationHelper";
import { getRoleLabel } from "@/data/models/RoleSettings";

@Component({
  components: {
    "user-form": UserFormComponent,
  },
})
export default class UserItemComponent extends Vue {
  @Prop() readonly user!: User;
  @Prop() elevation!: number;
  /** Marks the row opened last, or the dark-mode hover; set by the list. */
  @Prop({ default: "" }) readonly backgroundStyle!: string;

  @Ref("userForm")
  userFormDialog!: UserFormComponent;

  async openDetails() {
    this.$emit("opened", this.user);
    await this.userFormDialog.show(this.user);
  }

  onDialogClosed() {
    this.$emit("userDialogClosed");
  }

  get licences() {
    const licences = getLatestLicences(this.user.licenceInfo) ?? [];

    return licences
      .map((licence) => localiceLicence(licence, this).substring(0, 1))
      .join("");
  }

  get admin() {
    if (getAdminFlag(this.user)) {
      return this.$t("common.isAdmin");
    }
    return "";
  }

  get validationLevel(): string {
    return formatUserValidationLevel(this, this.user.validationLevel);
  }

  get roleLabel(): string {
    const role = this.user.role;
    if (!role) return "";
    return getRoleLabel(role, this);
  }
}
